import { ApiError } from '@/error-handler/types'

export const includesAuthError = (errors: Array<ApiError>): boolean => errors.some(e => isAuthError(e))

export const isAuthError = (error: ApiError): boolean => error.code === 401
